import {NavLink} from "react-router-dom";

interface PaginationProps {
    postsPerPage: number;
    totalPosts: number;
    paginate: Function;
    currentPage: number;
    parentURL: string;
}


export default function Pagination(props: PaginationProps) {

    const {postsPerPage, totalPosts, paginate, currentPage, parentURL} = props

    let pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
        pageNumbers.push(i);
    }
    // console.log(pageNumbers)


    // This function forms a range of pages around current page: [5 before - current Page - 5 after]
    function getRange(thisPage: number, pagesArray: number[]) {
        let thisPageIndex = pagesArray.indexOf(thisPage)
        let pagesBefore = pagesArray.slice(0, thisPageIndex)
        let pagesAfter = pagesArray.slice(thisPageIndex)
        let out: number[]

        if (pagesBefore.length >= 5 && pagesAfter.length >= 5) {
            out = [...pagesArray.slice(thisPageIndex - 5, thisPageIndex), ...pagesArray.slice(thisPageIndex, thisPageIndex + 5)]

        } else if (pagesBefore.length < 5 && pagesAfter.length >= 5) {
            let deficit: number = 10 - pagesBefore.length

            if (pagesAfter.length >= deficit) {
                out = [...pagesArray.slice(0, thisPageIndex), ...pagesArray.slice(thisPageIndex, thisPageIndex + deficit)]
            } else {
                out = [...pagesArray.slice(0, thisPageIndex), ...pagesArray.slice(thisPageIndex)]
            }

        } else if (pagesBefore.length >= 5 && pagesAfter.length < 5) {
            let deficit: number = 10 - pagesAfter.length

            if (pagesBefore.length >= deficit) {
                out = [...pagesArray.slice(thisPageIndex - deficit, thisPageIndex), ...pagesArray.slice(thisPageIndex)]
            } else {
                out = [...pagesArray.slice(0, thisPageIndex), ...pagesArray.slice(thisPageIndex)]
            }

        } else {
            out = pagesArray
        }
        return out
    }

    let pagesRange = getRange(currentPage, pageNumbers)
    // console.log(pagesRange)


    function paginationBtn(pageNum:any, label?:string) {

        return <NavLink
            key={pageNum}
            to={parentURL + pageNum}
            onClick={() => paginate(pageNum)}
            className={pageNum === currentPage ? 'pgn-item pgn-item-current' : 'pgn-item'}
        >
            {label ? label : pageNum}
        </NavLink>
    }


    return (
        <div className="pgn-container">
            <div className='pgn-sub'>

                {/* Go To First Page */}
                {currentPage >= 7 && paginationBtn(1, '<<') }

                {pagesRange.map(number => (
                    // {pageNumbers.map(number => (
                    paginationBtn(number)

                ))}

                {/* Go To Last Page */}
                {pagesRange.length >=10 && currentPage !== pageNumbers.at(-1) && paginationBtn(pageNumbers.at(-1), '>>')}

            </div>
        </div>

    );
};